import { ReactNode } from 'react';
import { FlexColumn } from 'components/layout/FlexColumn/FlexColumn';
import { SidebarFooter } from 'components/layout/SidebarLayout';
import { FilterContextProvider } from 'components/widgets/FilterToolbar/FilterContext';
import CompaniesFilter from 'components/widgets/FilterToolbar/filters/Companies';
import CountySelection from 'components/widgets/FilterToolbar/filters/CountySelection';
import KeywordsFilter from 'components/widgets/FilterToolbar/filters/Keywords';
import LatestProjectState from 'components/widgets/FilterToolbar/filters/LatestProjectStage';
import PresetFilterMenu from 'components/widgets/FilterToolbar/filters/LatestProjectStage/PresetFilterMenu';
import LocationDropdown from 'components/widgets/FilterToolbar/filters/LocationDropdown';
import LotSizeInAcres from 'components/widgets/FilterToolbar/filters/LotSizeInAcres';
import PastProjectStageFilter from 'components/widgets/FilterToolbar/filters/PastProjectStages';
import ProjectSize from 'components/widgets/FilterToolbar/filters/ProjectSize';
import ProjectValueFilter from 'components/widgets/FilterToolbar/filters/ProjectValue';
import RegionSelection from 'components/widgets/FilterToolbar/filters/RegionSelection';
import SectorsFilter from 'components/widgets/FilterToolbar/filters/Sectors';
import StakeholdersInvolved from 'components/widgets/FilterToolbar/filters/StakeholdersInvolved';
import StateSelection from 'components/widgets/FilterToolbar/filters/StateSelection';
import WorkTypeFilter from 'components/widgets/FilterToolbar/filters/WorkType';
import ZonesFilter from 'components/widgets/FilterToolbar/filters/Zones';
import FilterSectionLabel from 'components/widgets/FilterToolbar/FilterSectionLabel';

const containerStyle = {
  height: '100%',
  width: '100%',
};

const filterScroll = {
  overflowY: 'auto',
  width: '100%',
  flex: 1,
};

type TFilterToolbarProps = {
  headerElement?: ReactNode;
  extraFilters?: ReactNode;
  footerElement?: ReactNode;
  onLocationChangeCallback?: () => void;
  showCompaniesFilter?: boolean;
};

const FilterToolbar = ({
  headerElement,
  extraFilters,
  footerElement,
  onLocationChangeCallback,
  showCompaniesFilter = true,
}: TFilterToolbarProps) => {
  return (
    <FilterContextProvider>
      <FlexColumn sx={containerStyle}>
        {headerElement && headerElement}
        <FlexColumn sx={filterScroll}>
          <FilterSectionLabel label="Location" isFirst />
          <StateSelection onLocationChangeCallback={onLocationChangeCallback} />
          <RegionSelection />
          <CountySelection />
          <LocationDropdown />
          {extraFilters && extraFilters}
          <FilterSectionLabel label="Lead Type" />
          <PresetFilterMenu />
          <LatestProjectState />
          <PastProjectStageFilter />
          <StakeholdersInvolved />
          <FilterSectionLabel label="Project Type" />
          <SectorsFilter />
          <WorkTypeFilter />
          <ProjectValueFilter />
          <ProjectSize />
          <LotSizeInAcres />
          <FilterSectionLabel label="Advanced Filters" />
          <KeywordsFilter />
          {showCompaniesFilter && <CompaniesFilter />}
          <ZonesFilter />
        </FlexColumn>
        {footerElement && <SidebarFooter>{footerElement}</SidebarFooter>}
      </FlexColumn>
    </FilterContextProvider>
  );
};

export default FilterToolbar;
